import { useRef, useState, type FormEvent } from "react";
import { sanitizeHatchName } from "./HatchPanel";
import { SheetOverlay } from "./SheetOverlay";

export interface RenameSheetProps {
  currentName: string;
  onRename(name: string): void;
  onClose(): void;
}

const NAMES = ["Biscuit", "Pepper", "Mochi", "Waffles", "Scout", "Clover"];

export function RenameSheet({ currentName, onRename, onClose }: RenameSheetProps) {
  const [name, setName] = useState(currentName);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const validName = sanitizeHatchName(name);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!validName) return;
    onRename(validName);
    onClose();
  }

  return (
    <SheetOverlay
      testId="rename-sheet"
      title="Rename your pet"
      initialFocusRef={inputRef}
      onClose={onClose}
    >
      <form className="sb" onSubmit={handleSubmit}>
        <label className="vh" htmlFor="pname">
          Pet name
        </label>
        <div className="fi">
          <input
            ref={inputRef}
            id="pname"
            maxLength={12}
            value={name}
            autoComplete="off"
            data-testid="rename-input"
            onChange={(e) => setName(e.target.value)}
          />
          <button
            className="btn"
            type="submit"
            disabled={validName === null}
            data-testid="rename-save"
          >
            Save
          </button>
        </div>

        <h4>Ideas</h4>
        <div className="chips">
          {NAMES.map((n) => (
            <button
              key={n}
              className="chip"
              type="button"
              data-testid={`rename-chip-${n}`}
              onClick={() => setName(n)}
            >
              {n}
            </button>
          ))}
        </div>

        <div className="note">
          1 to 12 letters or numbers. Typed names stay on your device. Friends see the animal type
          instead.
        </div>
      </form>
    </SheetOverlay>
  );
}
